/**
 * Textos longos das páginas de detalhe de serviço (PT / EN / FR).
 * Ícones e gradientes ficam em ServiceDetail.js (SERVICE_LAYOUTS).
 */

const engCivilItemsPt = [
  ['Projetos e Execução de Obras', 'Projetos e execução de obras civis (residenciais, comerciais e industriais)'],
  ['Projetos Arquitetônicos', 'Elaboração de projetos arquitetônicos, estruturais e complementares'],
  ['Planejamento e Gestão', 'Planejamento, fiscalização e gestão de obras'],
  ['Infraestruturas', 'Infraestruturas elétricas, hidráulicas e de rede'],
  ['Estudos Técnicos', 'Estudos de viabilidade, topografia e sondagem'],
  ['Construção Sustentável', 'Construção sustentável e soluções com eficiência energética'],
  ['Manutenção Predial', 'Manutenção predial e retrofit de edifícios'],
  ['Consultoria em Licenciamento', 'Consultoria em licenciamento urbano e ambiental'],
]
const engCivilItemsEn = [
  ['Projects & construction delivery', 'Design and delivery of civil works (residential, commercial and industrial)'],
  ['Architectural design', 'Architectural, structural and complementary design'],
  ['Planning & management', 'Planning, supervision and construction management'],
  ['Infrastructure', 'Electrical, hydraulic and network infrastructure'],
  ['Technical studies', 'Feasibility studies, surveying and geotechnical investigation'],
  ['Sustainable construction', 'Sustainable construction and energy-efficiency solutions'],
  ['Building maintenance', 'Building maintenance and retrofit of structures'],
  ['Permitting advisory', 'Urban and environmental permitting advisory'],
]
const engCivilItemsFr = [
  ['Projets et réalisation de chantiers', 'Projets et réalisation d’ouvrages civils (résidentiels, commerciaux et industriels)'],
  ['Projets architecturaux', 'Conception architecturale, structurelle et complémentaire'],
  ['Planification et gestion', 'Planification, surveillance et gestion de chantier'],
  ['Infrastructures', 'Infrastructures électriques, hydrauliques et réseaux'],
  ['Études techniques', 'Études de faisabilité, topographie et reconnaissance de sols'],
  ['Construction durable', 'Construction durable et solutions à haute efficacité énergétique'],
  ['Maintenance immobilière', 'Maintenance de bâtiments et réhabilitation d’ouvrages'],
  ['Conseil en autorisations', 'Conseil en urbanisme et autorisations environnementales'],
]

function items(pairs) {
  return pairs.map(([title, description]) => ({ title, description }))
}

const engCivil = {
  pt: {
    h1Main: 'Engenharia Civil e',
    h1Highlight: 'Infraestruturas Sustentáveis',
    description:
      'Oferecemos soluções completas em engenharia civil, desde o planejamento até a execução de obras, sempre com foco na sustentabilidade e eficiência energética.',
    sectionTopic: 'engenharia civil e infraestruturas sustentáveis',
    ctaTitle: 'Pronto para começar seu projeto?',
    ctaDescription:
      'Entre em contato conosco para uma consulta gratuita e descubra como podemos transformar suas ideias em realidade com soluções sustentáveis e inovadoras.',
    ctaButton: 'Solicitar Orçamento',
    ctaButton2: 'Conheça Nossa Empresa',
    ctaLink2: '/sobre',
    items: items(engCivilItemsPt),
  },
  en: {
    h1Main: 'Civil engineering &',
    h1Highlight: 'sustainable infrastructure',
    description:
      'End-to-end civil engineering from planning to delivery, with a strong focus on sustainability and energy performance.',
    sectionTopic: 'civil engineering and sustainable infrastructure',
    ctaTitle: 'Ready to start your project?',
    ctaDescription:
      'Contact us for a free consultation and see how we can turn your ideas into reality with sustainable, innovative solutions.',
    ctaButton: 'Request a quote',
    ctaButton2: 'About us',
    ctaLink2: '/sobre',
    items: items(engCivilItemsEn),
  },
  fr: {
    h1Main: 'Génie civil et',
    h1Highlight: 'infrastructures durables',
    description:
      'Solutions complètes de génie civil, de la conception à la réalisation, avec une attention constante à la durabilité et à la performance énergétique.',
    sectionTopic: 'génie civil et infrastructures durables',
    ctaTitle: 'Prêt à lancer votre projet ?',
    ctaDescription:
      'Contactez-nous pour une consultation gratuite et découvrez comment nous concrétisons vos idées avec des solutions durables et innovantes.',
    ctaButton: 'Demander un devis',
    ctaButton2: 'Découvrir l’entreprise',
    ctaLink2: '/sobre',
    items: items(engCivilItemsFr),
  },
}

const tecnologiaItemsPt = [
  ['Desenvolvimento de Software', 'Desenvolvimento de softwares sob medida (web e mobile)'],
  ['Websites e Plataformas', 'Criação, hospedagem e gestão de websites e plataformas digitais'],
  ['Integração de Sistemas', 'Integração de APIs, ERP e plataformas empresariais'],
  ['Transformação Digital', 'Transformação digital e automação de processos'],
  ['Business Intelligence', 'Business Intelligence: análise de dados e dashboards interativos'],
  ['Infraestrutura de TI', 'Gestão de infraestrutura de TI (cloud, servidores, redes)'],
  ['Sistemas ERP', 'Implantação e suporte técnico a sistemas ERP'],
  ['Suporte Técnico', 'Manutenção de equipamentos, suporte remoto e helpdesk'],
]
const tecnologiaItemsEn = [
  ['Software development', 'Custom software (web and mobile)'],
  ['Websites & platforms', 'Design, hosting and management of websites and digital platforms'],
  ['Systems integration', 'API, ERP and enterprise platform integration'],
  ['Digital transformation', 'Digital transformation and process automation'],
  ['Business intelligence', 'Data analytics and interactive dashboards'],
  ['IT infrastructure', 'IT infrastructure management (cloud, servers, networks)'],
  ['ERP systems', 'ERP implementation and technical support'],
  ['Technical support', 'Hardware maintenance, remote support and helpdesk'],
]
const tecnologiaItemsFr = [
  ['Développement logiciel', 'Logiciels sur mesure (web et mobile)'],
  ['Sites et plateformes', 'Création, hébergement et gestion de sites et plateformes numériques'],
  ['Intégration de systèmes', 'API, ERP et plateformes métier'],
  ['Transformation numérique', 'Transformation numérique et automatisation des processus'],
  ['Business intelligence', 'Analyse de données et tableaux de bord interactifs'],
  ['Infrastructure informatique', 'Cloud, serveurs et réseaux'],
  ['Progiciels ERP', 'Déploiement et support des systèmes ERP'],
  ['Support technique', 'Maintenance, assistance à distance et helpdesk'],
]

const tecnologia = {
  pt: {
    h1Main: 'Tecnologia da Informação e',
    h1Highlight: 'Inovação Digital',
    description:
      'Impulsionamos seu negócio com soluções tecnológicas inovadoras, desde desenvolvimento de software até transformação digital completa.',
    sectionTopic: 'tecnologia da informação e inovação digital',
    ctaTitle: 'Pronto para a transformação digital?',
    ctaDescription:
      'Conte com nossa expertise para levar seu negócio ao próximo nível tecnológico. Soluções personalizadas e suporte completo para suas necessidades.',
    ctaButton: 'Solicitar Consultoria',
    ctaButton2: 'Conheça Nossa Equipe',
    ctaLink2: '/sobre',
    items: items(tecnologiaItemsPt),
  },
  en: {
    h1Main: 'Information technology &',
    h1Highlight: 'digital innovation',
    description:
      'We accelerate your business with innovative technology, from software development to full digital transformation.',
    sectionTopic: 'information technology and digital innovation',
    ctaTitle: 'Ready for digital transformation?',
    ctaDescription:
      'Rely on our expertise to take your business to the next level with tailored solutions and end-to-end support.',
    ctaButton: 'Request consulting',
    ctaButton2: 'Meet our team',
    ctaLink2: '/sobre',
    items: items(tecnologiaItemsEn),
  },
  fr: {
    h1Main: 'Technologies de l’information et',
    h1Highlight: 'innovation numérique',
    description:
      'Nous faisons progresser votre entreprise avec des solutions technologiques innovantes, du développement logiciel à la transformation numérique complète.',
    sectionTopic: 'technologies de l’information et innovation numérique',
    ctaTitle: 'Prêt pour la transformation numérique ?',
    ctaDescription:
      'Bénéficiez de notre expertise pour passer au niveau supérieur avec des solutions sur mesure et un accompagnement complet.',
    ctaButton: 'Demander un conseil',
    ctaButton2: 'Découvrir l’équipe',
    ctaLink2: '/sobre',
    items: items(tecnologiaItemsFr),
  },
}

const cibersegurancaItemsPt = [
  [
    'Governança de SI, Consultoria',
    'Apoiamos políticas de segurança, auditorias, avaliação de riscos e planos de resposta a incidentes, para que a sua organização esteja preparada perante ameaças cibernéticas actuais.',
  ],
  [
    'Arquitectura, Implementação de Segurança',
    'Desenhamos a arquitectura de protecção mais adequada a cada cliente, alinhando controlos, processos e tecnologia ao perfil de risco e às exigências regulatórias.',
  ],
  [
    'Blue Team, Defesa e Monitorização',
    'Reforçamos a linha defensiva com vigilância contínua, gestão de vulnerabilidades e tratamento estruturado de incidentes, apoiados em ferramentas avançadas de detecção.',
  ],
  [
    'Red Team, Testes Ofensivos',
    'Conduzimos simulações de ataque e testes de intrusão para identificar fragilidades antes de serem exploradas, com relatórios objectivos e acções de correcção prioritárias.',
  ],
  [
    'Purple Team, Coordenação Estratégica',
    'Unimos equipas ofensivas e defensivas num ciclo de melhoria: partilha de conhecimento, formação de operadores e evolução contínua da postura de cibersegurança.',
  ],
  [
    'SOC, Centro de Operações de Segurança',
    'Projectamos, implementamos e operamos SOC à medida, com detecção em tempo real e resposta rápida; formamos também equipas internas para operação autónoma.',
  ],
  [
    'MSSP, Segurança Gerida 24/7',
    'Monitorização permanente, resposta imediata a incidentes e análise proactiva de ameaças emergentes, com especialistas SOSVOR dedicados ao seu ambiente.',
  ],
  [
    'Continuidade de Negócio, DLP',
    'Estruturamos planos de continuidade operacional e prevenção de perda de dados, assegurando classificação, confidencialidade e integridade dos activos informacionais.',
  ],
]

const cibersegurancaItemsEn = [
  [
    'Information security governance, advisory',
    'Security policies, audits, risk assessments and incident response planning so your organisation stays ready for today’s cyber threats.',
  ],
  [
    'Security architecture, implementation',
    'We design protection architectures tailored to each client, aligning controls, processes and technology with risk profile and compliance needs.',
  ],
  [
    'Blue Team, defence & monitoring',
    'Continuous monitoring, vulnerability management and structured incident handling using modern detection and response tooling.',
  ],
  [
    'Red Team, offensive testing',
    'Controlled attack simulations and penetration tests to surface weaknesses early, with clear remediation priorities.',
  ],
  [
    'Purple Team, coordinated improvement',
    'Offensive and defensive teams work together: intelligence sharing, operator training and ongoing uplift of cyber capabilities.',
  ],
  [
    'SOC, Security Operations Center',
    'Custom SOC design, deployment and operation with real-time threat detection; we also train in-house teams to run their own SOC.',
  ],
  [
    'MSSP, managed security 24/7',
    'Round-the-clock monitoring, rapid incident response and proactive analysis of emerging threats by SOSVOR specialists.',
  ],
  [
    'Business continuity, DLP',
    'Operational continuity plans and data loss prevention to protect sensitive information, classification and data integrity.',
  ],
]

const cibersegurancaItemsFr = [
  [
    'Gouvernance SI, conseil',
    'Politiques de sécurité, audits, analyse des risques et plans de réponse aux incidents pour faire face aux menaces cyber actuelles.',
  ],
  [
    'Architecture, mise en œuvre de la sécurité',
    'Conception d’architectures de protection adaptées, alignées sur le profil de risque et les exigences réglementaires.',
  ],
  [
    'Blue Team, défense et surveillance',
    'Surveillance continue, gestion des vulnérabilités et traitement structuré des incidents avec des outils de détection avancés.',
  ],
  [
    'Red Team, tests offensifs',
    'Simulations d’attaque et tests d’intrusion pour corriger les failles avant exploitation, avec priorités claires.',
  ],
  [
    'Purple Team, coordination stratégique',
    'Rapprochement des équipes offensive et défensive : partage de connaissances, formation et amélioration continue.',
  ],
  [
    'SOC, centre d’opérations de sécurité',
    'Conception, déploiement et exploitation de SOC sur mesure avec détection en temps réel ; formation des équipes internes.',
  ],
  [
    'MSSP, sécurité managée 24/7',
    'Monitoring permanent, réponse rapide aux incidents et analyse proactive des menaces émergentes.',
  ],
  [
    'Continuité d’activité, DLP',
    'Plans de continuité et prévention de la perte de données pour protéger les informations sensibles et leur intégrité.',
  ],
]

const ciberseguranca = {
  pt: {
    h1Main: 'Segurança da Informação e',
    h1Highlight: 'Cibersegurança',
    description:
      'Na SOSVOR, protegemos activos digitais de organizações e empresas com serviços completos de segurança da informação, da governança à operação 24/7, alinhados às melhores práticas internacionais.',
    sectionTopic: 'segurança da informação e cibersegurança',
    ctaTitle: 'Confiança para crescer com segurança',
    ctaDescription:
      'A nossa missão é dar-lhe tranquilidade: concentre-se no crescimento do negócio enquanto a SOSVOR cuida da protecção digital, da continuidade operacional e da disponibilidade dos seus serviços.',
    ctaButton: 'Entrar em Contacto',
    ctaButton2: 'Conheça a SOSVOR',
    ctaLink2: '/sobre',
    items: items(cibersegurancaItemsPt),
  },
  en: {
    h1Main: 'Information security &',
    h1Highlight: 'cybersecurity',
    description:
      'At SOSVOR we protect organisations’ digital assets with end-to-end information security, from governance to 24/7 operations, aligned with international best practice.',
    sectionTopic: 'information security and cybersecurity',
    ctaTitle: 'Grow with confidence',
    ctaDescription:
      'Our mission is peace of mind: focus on your business growth while SOSVOR safeguards digital assets, operational continuity and service availability.',
    ctaButton: 'Contact us',
    ctaButton2: 'About SOSVOR',
    ctaLink2: '/sobre',
    items: items(cibersegurancaItemsEn),
  },
  fr: {
    h1Main: 'Sécurité de l’information et',
    h1Highlight: 'cybersécurité',
    description:
      'Chez SOSVOR, nous protégeons les actifs numériques des organisations avec une offre complète, de la gouvernance à l’exploitation 24/7, conforme aux meilleures pratiques du secteur.',
    sectionTopic: 'sécurité de l’information et cybersécurité',
    ctaTitle: 'Grandir en toute confiance',
    ctaDescription:
      'Notre mission : vous apporter sérénité opérationnelle pendant que SOSVOR assure protection numérique, continuité et disponibilité de vos services.',
    ctaButton: 'Nous contacter',
    ctaButton2: 'Découvrir SOSVOR',
    ctaLink2: '/sobre',
    items: items(cibersegurancaItemsFr),
  },
}

const gestaoProcessosItemsPt = [
  [
    'Missão, Simplificar e acelerar resultados',
    'Aliviamos a rotina operacional da sua empresa e convertemos esforço em ganhos mensuráveis, libertando o potencial das equipas com gestão e automação inteligente de processos.',
  ],
  [
    'Proposta de Valor, Visibilidade e governo integrado',
    'Orquestramos pessoas, processos e tecnologias numa abordagem flexível e escalável: visibilidade completa, conformidade reforçada e decisões sustentadas em dados, com automação que elimina tarefas repetitivas.',
  ],
  [
    'Área de Actuação, Do backoffice ao estratégico',
    'Intervimos em múltiplas frentes, desde funções de suporte até processos críticos, mapeando fluxos, detectando oportunidades e implementando soluções que geram eficiência, governança e capacidade de escalar.',
  ],
  [
    'Gap Analyser, Diagnóstico de lacunas',
    'Avaliamos a maturidade dos processos actuais, identificamos gaps entre o estado presente e o desejado e priorizamos acções com impacto directo na produtividade e na governança.',
  ],
  [
    'Modelagem, Hiperautomação de fluxos',
    'Desenhamos e automatizamos processos de ponta a ponta, reduzindo erros manuais e acelerando a execução com ferramentas modernas de BPM e RPA.',
  ],
  [
    'Desmaterialização, Gestão sem papel',
    'Digitalizamos documentos e fluxos administrativos, centralizando informação num ambiente único, seguro e rastreável, com acesso rápido e controlado.',
  ],
  [
    'BPMO, Estruturação de escritórios',
    'Apoiamos a criação e operação de Business Process Management Offices, com governance, métricas, papéis definidos e ritos de melhoria contínua.',
  ],
  [
    'Formações, Capacitação de equipas',
    'Formamos colaboradores e líderes em metodologias de processos, automação e ferramentas, assegurando adopção sustentada e autonomia operacional.',
  ],
]

const gestaoProcessosItemsEn = [
  [
    'Mission, Simplify and accelerate outcomes',
    'We lighten operational routine and turn effort into measurable gains, unlocking team potential through intelligent process management and automation.',
  ],
  [
    'Value proposition, Integrated visibility and control',
    'We orchestrate people, processes and technology in a flexible, scalable approach: full visibility, stronger compliance and data-driven decisions, with automation that removes repetitive work.',
  ],
  [
    'Scope, From back office to strategic core',
    'We work across the organisation, from support functions to critical processes, mapping flows, spotting opportunities and delivering efficiency, governance and scalability.',
  ],
  [
    'Gap Analyser, Process gap diagnosis',
    'We assess current process maturity, identify gaps between as-is and target state, and prioritise actions with direct impact on productivity and governance.',
  ],
  [
    'Modelling, Hyperautomation of workflows',
    'We design and automate end-to-end processes, cutting manual errors and speeding execution with modern BPM and RPA tooling.',
  ],
  [
    'Dematerialisation, Paperless operations',
    'We digitise documents and administrative flows, centralising information in a single secure, traceable environment with fast, controlled access.',
  ],
  [
    'BPMO, Office setup and structure',
    'We help establish and run Business Process Management Offices with governance, metrics, clear roles and continuous improvement routines.',
  ],
  [
    'Training, Team enablement',
    'We upskill staff and leaders in process methods, automation and tools, ensuring sustained adoption and operational autonomy.',
  ],
]

const gestaoProcessosItemsFr = [
  [
    'Mission, Simplifier et accélérer les résultats',
    'Nous allégeons la routine opérationnelle et transformons l’effort en gains mesurables, en libérant le potentiel des équipes grâce à la gestion et l’automatisation intelligente des processus.',
  ],
  [
    'Proposition de valeur, Visibilité et pilotage intégrés',
    'Nous orchestrons personnes, processus et technologies dans une approche flexible et évolutive : visibilité complète, conformité renforcée et décisions fondées sur les données, avec automatisation des tâches répétitives.',
  ],
  [
    'Périmètre, Du back-office au stratégique',
    'Nous intervenons sur de multiples fronts, du support aux processus critiques, en cartographiant les flux, identifiant les opportunités et déployant efficacité, gouvernance et scalabilité.',
  ],
  [
    'Gap Analyser, Diagnostic des écarts',
    'Nous évaluons la maturité des processus, identifions les écarts entre l’existant et la cible, et priorisons les actions à impact direct sur productivité et gouvernance.',
  ],
  [
    'Modélisation, Hyperautomatisation des flux',
    'Nous concevons et automatisons les processus de bout en bout, réduisant les erreurs manuelles et accélérant l’exécution avec des outils BPM et RPA modernes.',
  ],
  [
    'Dématérialisation, Gestion sans papier',
    'Nous numérisons documents et flux administratifs, centralisant l’information dans un environnement unique, sécurisé et traçable.',
  ],
  [
    'BPMO, Structuration des bureaux',
    'Nous accompagnons la création et l’exploitation de Business Process Management Offices, avec gouvernance, indicateurs et rituels d’amélioration continue.',
  ],
  [
    'Formations, Montée en compétences',
    'Nous formons collaborateurs et managers aux méthodes processus, à l’automatisation et aux outils, pour une adoption durable et une autonomie opérationnelle.',
  ],
]

const gestaoProcessosIntroBg = '/img/gestao-processos-intro-bg.png'

const gestaoProcessos = {
  pt: {
    h1Main: 'Gestão Inteligente de',
    h1Highlight: 'Processos',
    introBackground: gestaoProcessosIntroBg,
    description:
      'Impulsione produtividade e governança com consultoria especializada em optimização de processos de negócio. Avance da ineficiência para uma gestão ágil, orientada por dados e preparada para escalar, em Angola e além.',
    sectionTopic: 'gestão inteligente de processos',
    ctaTitle: 'Processe o crescimento. Simplifique a gestão.',
    ctaDescription:
      'Domine o seu negócio com a SOSVOR: aumentamos produtividade, reduzimos erros e maximizamos o retorno dos seus activos tecnológicos com transformação operacional com sentido.',
    ctaButton: 'Entrar em Contacto',
    ctaButton2: 'Conheça a SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(gestaoProcessosItemsPt.slice(0, 3)),
    items: items(gestaoProcessosItemsPt.slice(3)),
  },
  en: {
    h1Main: 'Intelligent process',
    h1Highlight: 'management',
    introBackground: gestaoProcessosIntroBg,
    description:
      'Boost productivity and governance with specialised business process optimisation consulting. Move from inefficiency to agile, data-driven management built to scale, in Angola and beyond.',
    sectionTopic: 'intelligent process management',
    ctaTitle: 'Process growth. Simplify management.',
    ctaDescription:
      'Master your business with SOSVOR: we increase productivity, reduce errors and maximise return on your technology assets through meaningful operational transformation.',
    ctaButton: 'Contact us',
    ctaButton2: 'About SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(gestaoProcessosItemsEn.slice(0, 3)),
    items: items(gestaoProcessosItemsEn.slice(3)),
  },
  fr: {
    h1Main: 'Gestion intelligente des',
    h1Highlight: 'processus',
    introBackground: gestaoProcessosIntroBg,
    description:
      'Renforcez productivité et gouvernance grâce à notre conseil en optimisation des processus métiers. Passez de l’inefficacité à une gestion agile, orientée données et prête à évoluer, en Angola et au-delà.',
    sectionTopic: 'gestion intelligente des processus',
    ctaTitle: 'Traitez la croissance. Simplifiez la gestion.',
    ctaDescription:
      'Maîtrisez votre activité avec SOSVOR : nous augmentons la productivité, réduisons les erreurs et maximisons le retour de vos actifs technologiques par une transformation opérationnelle utile.',
    ctaButton: 'Nous contacter',
    ctaButton2: 'Découvrir SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(gestaoProcessosItemsFr.slice(0, 3)),
    items: items(gestaoProcessosItemsFr.slice(3)),
  },
}

const aplicacoesGestaoItemsPt = [
  [
    'Missão, Gestão integrada e transparente',
    'Entregamos soluções de gestão seguras e conectadas que reforçam transparência, eficiência operacional e decisões estratégicas em ambientes corporativos e institucionais.',
  ],
  [
    'Proposta de Valor, Personalização e conformidade',
    'Soluções modulares, escaláveis e interoperáveis que optimizam rotinas administrativas, elevam produtividade e asseguram aderência a legislação e boas práticas de governança pública e privada.',
  ],
  [
    'Área de Actuação, Módulos para cada sector',
    'Cobrimos finanças, contabilidade, contratos, compras, almoxarifado, património e frota, com foco em interoperabilidade com sistemas legados, automação de processos e adaptação à realidade de cada organização.',
  ],
  [
    'Levantamento, Análise de requisitos',
    'Mapeamos necessidades funcionais e técnicas, alinhamos stakeholders e definimos roadmaps claros antes de desenvolver ou modernizar qualquer módulo de backoffice.',
  ],
  [
    'Desenvolvimento, Modernização de backoffice',
    'Construímos e evoluímos aplicações de gestão modulares para uso corporativo e institucional, com arquitectura preparada para crescer e integrar-se ao ecossistema existente.',
  ],
  [
    'Testes, Fábrica e automação de QA',
    'Operamos fábrica de testes com cenários automatizados e validação contínua, garantindo qualidade, estabilidade e confiança antes de cada entrada em produção.',
  ],
  [
    'Integração, ERPs e plataformas públicas',
    'Conectamos soluções a ERPs, sistemas governamentais e plataformas de pagamento, preservando dados críticos e eliminando silos entre áreas administrativas.',
  ],
  [
    'Módulos Transversais, Finanças a frota',
    'Administração financeira e orçamental, contabilidade pública e empresarial, contratos e convénios, licitações, almoxarifado, património e gestão de frotas numa visão unificada.',
  ],
]

const aplicacoesGestaoItemsEn = [
  [
    'Mission, Integrated, transparent management',
    'We deliver secure, connected management solutions that strengthen transparency, operational efficiency and strategic decision-making in corporate and public settings.',
  ],
  [
    'Value proposition, Tailored and compliant',
    'Modular, scalable, interoperable solutions that streamline administrative routines, boost productivity and meet public and private governance standards.',
  ],
  [
    'Scope, Modules for every sector',
    'We cover finance, accounting, contracts, procurement, warehousing, assets and fleet, with legacy interoperability, process automation and solutions adapted to each organisation.',
  ],
  [
    'Discovery, Requirements analysis',
    'We map functional and technical needs, align stakeholders and define clear roadmaps before building or modernising any back-office module.',
  ],
  [
    'Development, Back-office modernisation',
    'We build and evolve modular management applications for corporate and institutional use, with architecture designed to scale and integrate with existing systems.',
  ],
  [
    'Testing, QA factory and automation',
    'We run a test factory with automated scenarios and continuous validation, ensuring quality, stability and confidence before every go-live.',
  ],
  [
    'Integration, ERPs and public platforms',
    'We connect solutions to ERPs, government systems and payment platforms, preserving critical data and removing silos across administrative areas.',
  ],
  [
    'Cross-cutting modules, Finance to fleet',
    'Budget and financial administration, public and corporate accounting, contracts, procurement, warehousing, assets and fleet management in a unified view.',
  ],
]

const aplicacoesGestaoItemsFr = [
  [
    'Mission, Gestion intégrée et transparente',
    'Nous livrons des solutions de gestion sécurisées et connectées qui renforcent transparence, efficacité opérationnelle et décisions stratégiques en environnement corporate et public.',
  ],
  [
    'Proposition de valeur, Personnalisation et conformité',
    'Solutions modulaires, évolutives et interopérables qui optimisent les routines administratives, accroissent la productivité et respectent gouvernance publique et privée.',
  ],
  [
    'Périmètre, Modules pour chaque secteur',
    'Nous couvrons finances, comptabilité, contrats, achats, magasin, patrimoine et flotte, avec interopérabilité legacy, automatisation et adaptation à chaque organisation.',
  ],
  [
    'Cadrage, Analyse des exigences',
    'Nous cartographions les besoins fonctionnels et techniques, alignons les parties prenantes et définissons des feuilles de route avant tout développement back-office.',
  ],
  [
    'Développement, Modernisation back-office',
    'Nous construisons et faisons évoluer des applications de gestion modulaires pour usage corporate et institutionnel, prêtes à évoluer et s’intégrer.',
  ],
  [
    'Tests, Usine et automatisation QA',
    'Usine de tests avec scénarios automatisés et validation continue pour garantir qualité, stabilité et confiance avant chaque mise en production.',
  ],
  [
    'Intégration, ERP et plateformes publiques',
    'Connexion aux ERP, systèmes gouvernementaux et plateformes de paiement, en préservant les données critiques et en supprimant les silos.',
  ],
  [
    'Modules transverses, Finances à flotte',
    'Administration financière et budgétaire, comptabilité publique et entreprise, contrats, marchés, magasin, patrimoine et gestion de flotte dans une vue unifiée.',
  ],
]

const aplicacoesGestaoIntroBg = '/img/aplicacoes-gestao-intro-bg.png'

const aplicacoesGestao = {
  pt: {
    h1Main: 'Aplicações de',
    h1Highlight: 'Gestão',
    introBackground: aplicacoesGestaoIntroBg,
    description:
      'Desenvolvemos, integramos e modernizamos aplicações de gestão modulares para uso corporativo e institucional, finanças, contabilidade, compras, contratos, património e frota, com interoperabilidade, automação e aderência às normas de governança.',
    sectionTopic: 'aplicações de gestão',
    ctaTitle: 'Foco no desenvolvimento, integração e modernização.',
    ctaDescription:
      'Transforme a gestão da sua organização com soluções SOSVOR seguras, integradas e preparadas para decisões estratégicas em ambientes públicos e privados.',
    ctaButton: 'Entrar em Contacto',
    ctaButton2: 'Conheça a SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(aplicacoesGestaoItemsPt.slice(0, 3)),
    items: items(aplicacoesGestaoItemsPt.slice(3)),
  },
  en: {
    h1Main: 'Management',
    h1Highlight: 'applications',
    introBackground: aplicacoesGestaoIntroBg,
    description:
      'We develop, integrate and modernise modular management applications for corporate and institutional use, finance, accounting, procurement, contracts, assets and fleet, with interoperability, automation and governance compliance.',
    sectionTopic: 'management applications',
    ctaTitle: 'Development, integration and modernisation.',
    ctaDescription:
      'Transform your organisation’s management with secure, integrated SOSVOR solutions built for strategic decisions in public and private environments.',
    ctaButton: 'Contact us',
    ctaButton2: 'About SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(aplicacoesGestaoItemsEn.slice(0, 3)),
    items: items(aplicacoesGestaoItemsEn.slice(3)),
  },
  fr: {
    h1Main: 'Applications de',
    h1Highlight: 'gestion',
    introBackground: aplicacoesGestaoIntroBg,
    description:
      'Nous développons, intégrons et modernisons des applications de gestion modulaires pour usage corporate et institutionnel, finances, comptabilité, achats, contrats, patrimoine et flotte, avec interopérabilité, automatisation et conformité.',
    sectionTopic: 'applications de gestion',
    ctaTitle: 'Développement, intégration et modernisation.',
    ctaDescription:
      'Transformez la gestion de votre organisation avec des solutions SOSVOR sécurisées, intégrées et adaptées aux décisions stratégiques en secteur public et privé.',
    ctaButton: 'Nous contacter',
    ctaButton2: 'Découvrir SOSVOR',
    ctaLink2: '/sobre',
    introItems: items(aplicacoesGestaoItemsFr.slice(0, 3)),
    items: items(aplicacoesGestaoItemsFr.slice(3)),
  },
}

const designItemsPt = [
  ['Design Gráfico', 'Design gráfico (identidade visual, branding, materiais institucionais)'],
  ['Design Editorial', 'Design editorial (livros, catálogos, apresentações profissionais)'],
  ['Criação de Logotipos', 'Criação de logotipos, mockups, artes digitais e materiais promocionais'],
  ['Design UI/UX', 'Design UI/UX para websites e aplicativos'],
  ['Design Publicitário', 'Design publicitário para campanhas online e offline'],
  ['Edição de Vídeos', 'Edição de vídeos institucionais e animações'],
  ['Consultoria Criativa', 'Consultoria criativa para projetos de comunicação e marketing'],
]
const designItemsEn = [
  ['Graphic design', 'Visual identity, branding and institutional materials'],
  ['Editorial design', 'Books, catalogues and professional presentations'],
  ['Logo & digital assets', 'Logos, mockups, digital artwork and promotional materials'],
  ['UI/UX design', 'UI/UX for websites and applications'],
  ['Advertising design', 'Creative for online and offline campaigns'],
  ['Video editing', 'Corporate videos and motion graphics'],
  ['Creative consulting', 'Communication and marketing creative direction'],
]
const designItemsFr = [
  ['Design graphique', 'Identité visuelle, branding et supports institutionnels'],
  ['Design éditorial', 'Livres, catalogues et présentations professionnelles'],
  ['Logotypes & créations', 'Logos, maquettes, visuels numériques et supports promotionnels'],
  ['Design UI/UX', 'Interfaces pour sites web et applications'],
  ['Design publicitaire', 'Campagnes en ligne et hors ligne'],
  ['Montage vidéo', 'Vidéos institutionnelles et animations'],
  ['Conseil créatif', 'Communication et marketing créatif'],
]

const designMarketing = {
  pt: {
    h1Main: 'Design e',
    h1Highlight: 'Comunicação Visual',
    description:
      'Criamos identidades visuais marcantes e soluções criativas que comunicam a essência da sua marca de forma impactante e memorável.',
    sectionTopic: 'design e comunicação visual',
    ctaTitle: 'Pronto para destacar sua marca?',
    ctaDescription:
      'Vamos criar juntos uma identidade visual única que represente verdadeiramente os valores e a personalidade da sua empresa.',
    ctaButton: 'Solicitar Briefing',
    ctaButton2: 'Ver Nosso Portfólio',
    ctaLink2: '/sobre',
    items: items(designItemsPt),
  },
  en: {
    h1Main: 'Design &',
    h1Highlight: 'visual communication',
    description:
      'We craft distinctive visual identities and creative solutions that express your brand with impact and clarity.',
    sectionTopic: 'design and visual communication',
    ctaTitle: 'Ready to elevate your brand?',
    ctaDescription:
      'Let’s build a unique visual identity that truly reflects your company’s values and personality.',
    ctaButton: 'Request a briefing',
    ctaButton2: 'View our portfolio',
    ctaLink2: '/sobre',
    items: items(designItemsEn),
  },
  fr: {
    h1Main: 'Design et',
    h1Highlight: 'communication visuelle',
    description:
      'Nous créons des identités visuelles fortes et des solutions créatives qui traduisent l’essence de votre marque.',
    sectionTopic: 'design et communication visuelle',
    ctaTitle: 'Prêt à faire rayonner votre marque ?',
    ctaDescription:
      'Créons ensemble une identité visuelle unique qui reflète vos valeurs et votre personnalité.',
    ctaButton: 'Demander un brief',
    ctaButton2: 'Voir le portfolio',
    ctaLink2: '/sobre',
    items: items(designItemsFr),
  },
}

const segItemsPt = [
  ['Videomonitoramento CCTV', 'Instalação e manutenção de sistemas de videomonitoramento (CCTV)'],
  ['Dispositivos IoT', 'Integração de dispositivos IoT para segurança residencial e empresarial'],
  ['Controle de Acesso', 'Sistemas de controle de acesso (biometria, RFID, reconhecimento facial)'],
  ['Alarmes e Sensores', 'Alarmes, cercas elétricas e sensores inteligentes'],
  ['Consultoria Personalizada', 'Consultoria e projetos personalizados de segurança eletrônica'],
  ['Monitoramento Remoto', 'Monitoramento remoto e soluções em nuvem'],
]
const segItemsEn = [
  ['CCTV video surveillance', 'Installation and maintenance of CCTV systems'],
  ['IoT devices', 'IoT integration for residential and business security'],
  ['Access control', 'Biometrics, RFID and facial recognition systems'],
  ['Alarms & sensors', 'Alarms, electric fencing and smart sensors'],
  ['Tailored consulting', 'Custom electronic security consulting and design'],
  ['Remote monitoring', 'Remote monitoring and cloud-based solutions'],
]
const segItemsFr = [
  ['Vidéosurveillance CCTV', 'Installation et maintenance de systèmes CCTV'],
  ['Objets connectés (IoT)', 'Intégration IoT pour la sécurité résidentielle et professionnelle'],
  ['Contrôle d’accès', 'Biométrie, RFID et reconnaissance faciale'],
  ['Alarmes et capteurs', 'Alarmes, clôtures électriques et capteurs intelligents'],
  ['Conseil sur mesure', 'Conseil et projets de sécurité électronique personnalisés'],
  ['Télésurveillance', 'Supervision à distance et solutions cloud'],
]

const seguranca = {
  pt: {
    h1Main: 'Segurança Eletrônica',
    h1Highlight: 'Inteligente',
    description:
      'Proteja seu patrimônio com as mais avançadas tecnologias em segurança eletrônica, IoT e sistemas de monitoramento inteligente.',
    sectionTopic: 'segurança eletrônica inteligente',
    ctaTitle: 'Proteja seu patrimônio hoje mesmo',
    ctaDescription:
      'Entre em contato para uma avaliação gratuita e descubra como nossas soluções podem aumentar a segurança do seu negócio ou residência.',
    ctaButton: 'Solicitar Avaliação',
    ctaButton2: 'Ver Nossos Projetos',
    ctaLink2: '/sobre',
    items: items(segItemsPt),
  },
  en: {
    h1Main: 'Electronic security,',
    h1Highlight: 'intelligent systems',
    description:
      'Protect your assets with advanced electronic security, IoT and intelligent monitoring.',
    sectionTopic: 'smart electronic security',
    ctaTitle: 'Protect what matters today',
    ctaDescription:
      'Book a free assessment and learn how we can improve security for your business or home.',
    ctaButton: 'Book an assessment',
    ctaButton2: 'See our projects',
    ctaLink2: '/sobre',
    items: items(segItemsEn),
  },
  fr: {
    h1Main: 'Sécurité électronique',
    h1Highlight: 'intelligente',
    description:
      'Protégez vos biens avec les technologies les plus avancées en sécurité électronique, IoT et supervision intelligente.',
    sectionTopic: 'sécurité électronique intelligente',
    ctaTitle: 'Sécurisez vos biens dès aujourd’hui',
    ctaDescription:
      'Demandez une évaluation gratuite et découvrez comment renforcer la sécurité de votre entreprise ou de votre domicile.',
    ctaButton: 'Demander une évaluation',
    ctaButton2: 'Voir nos réalisations',
    ctaLink2: '/sobre',
    items: items(segItemsFr),
  },
}

const turismoItemsPt = [
  ['Planejamento de Viagens', 'Planejamento de viagens pessoais, corporativas e familiares'],
  ['Passagens Aéreas', 'Emissão de passagens aéreas nacionais e internacionais'],
  ['Pacotes Personalizados', 'Elaboração de pacotes turísticos personalizados e temáticos'],
  ['Consultoria de Viagem', 'Consultoria para vistos, vacinas, seguros e documentação de viagem'],
  ['Reservas e Hospedagem', 'Reservas de transporte, hospedagem e serviços adicionais'],
  ['Turismo Corporativo (MICE)', 'Organização de viagens para eventos, congressos e incentivos (MICE)'],
  ['Atendimento VIP', 'Atendimento VIP, concierge e suporte 24h para emergências'],
  ['Plataforma Digital', 'Plataforma digital para cotações e gestão de reservas'],
]
const turismoItemsEn = [
  ['Trip planning', 'Personal, corporate and family travel planning'],
  ['Flight tickets', 'Domestic and international ticketing'],
  ['Tailor-made packages', 'Custom themed travel packages'],
  ['Travel advisory', 'Visas, vaccines, insurance and travel documents'],
  ['Bookings & hotels', 'Transport, accommodation and add-on services'],
  ['Corporate travel (MICE)', 'Events, conferences and incentive travel'],
  ['VIP service', 'VIP assistance, concierge and 24/7 emergency support'],
  ['Digital platform', 'Quotes and reservation management online'],
]
const turismoItemsFr = [
  ['Organisation de voyages', 'Voyages personnels, d’affaires et en famille'],
  ['Billets d’avion', 'Émission de billets nationaux et internationaux'],
  ['Forfaits sur mesure', 'Packages touristiques personnalisés et thématiques'],
  ['Conseil voyage', 'Visas, vaccins, assurances et documents'],
  ['Réservations', 'Transport, hébergement et services annexes'],
  ['Tourisme d’affaires (MICE)', 'Événements, congrès et voyages d’incentive'],
  ['Service VIP', 'Conciergerie et assistance d’urgence 24h/24'],
  ['Plateforme numérique', 'Devis et gestion des réservations en ligne'],
]

const turismo = {
  pt: {
    h1Main: 'Viagens e',
    h1Highlight: 'Turismo Inteligente',
    description:
      'Transformamos seus sonhos de viagem em experiências inesquecíveis com planejamento personalizado e atendimento de excelência.',
    sectionTopic: 'viagens e turismo inteligente',
    ctaTitle: 'Sua próxima aventura começa aqui',
    ctaDescription:
      'Entre em contato conosco e descubra como podemos transformar seus sonhos de viagem em experiências inesquecíveis e personalizadas.',
    ctaButton: 'Planejar Minha Viagem',
    ctaButton2: 'Solicitar Cotação',
    ctaLink2: '/contato',
    items: items(turismoItemsPt),
  },
  en: {
    h1Main: 'Travel &',
    h1Highlight: 'smart tourism',
    description:
      'We turn travel dreams into memorable experiences with tailored planning and outstanding service.',
    sectionTopic: 'travel and smart tourism',
    ctaTitle: 'Your next adventure starts here',
    ctaDescription:
      'Contact us to design unforgettable, personalised journeys.',
    ctaButton: 'Plan my trip',
    ctaButton2: 'Request a quote',
    ctaLink2: '/contato',
    items: items(turismoItemsEn),
  },
  fr: {
    h1Main: 'Voyages et',
    h1Highlight: 'tourisme intelligent',
    description:
      'Nous transformons vos envies de voyage en expériences mémorables grâce à une organisation sur mesure et un service d’excellence.',
    sectionTopic: 'voyages et tourisme intelligent',
    ctaTitle: 'Votre prochaine aventure commence ici',
    ctaDescription:
      'Contactez-nous pour des séjours inoubliables, entièrement personnalisés.',
    ctaButton: 'Organiser mon voyage',
    ctaButton2: 'Demander un devis',
    ctaLink2: '/contato',
    items: items(turismoItemsFr),
  },
}

const consultoriaItemsPt = [
  ['Fornecimento de Materiais', 'Fornecimento de materiais e soluções tecnológicas'],
  ['Importação e Exportação', 'Importação e exportação de equipamentos e produtos inovadores'],
  ['Cursos Técnicos', 'Organização de cursos técnicos, capacitações e workshops'],
  ['Formações Especializadas', 'Formações em tecnologia, engenharia, segurança e design'],
  ['Parcerias Estratégicas', 'Parcerias estratégicas para desenvolvimento de competências'],
]
const consultoriaItemsEn = [
  ['Materials supply', 'Technology materials and solutions sourcing'],
  ['Import & export', 'Innovative equipment and products trading'],
  ['Technical courses', 'Technical training, upskilling and workshops'],
  ['Specialised training', 'Technology, engineering, security and design programmes'],
  ['Strategic partnerships', 'Partnerships to build skills and capabilities'],
]
const consultoriaItemsFr = [
  ['Fourniture de matériels', 'Matériels et solutions technologiques'],
  ['Import-export', 'Équipements et produits innovants'],
  ['Cours techniques', 'Formations techniques, montées en compétence et ateliers'],
  ['Formations spécialisées', 'Technologie, ingénierie, sécurité et design'],
  ['Partenariats stratégiques', 'Développement des compétences en partenariat'],
]

const consultoria = {
  pt: {
    h1Main: 'Comércio Geral e',
    h1Highlight: 'Formação Técnica',
    description:
      'Fornecemos soluções completas em materiais tecnológicos e desenvolvemos competências através de formações técnicas especializadas.',
    sectionTopic: 'comércio geral e formação técnica',
    ctaTitle: 'Desenvolva suas competências conosco',
    ctaDescription:
      'Entre em contato para conhecer nossos cursos disponíveis ou solicitar um orçamento para fornecimento de materiais e equipamentos.',
    ctaButton: 'Ver Cursos Disponíveis',
    ctaButton2: 'Solicitar Orçamento',
    ctaLink2: '/contato',
    items: items(consultoriaItemsPt),
  },
  en: {
    h1Main: 'General trade &',
    h1Highlight: 'technical training',
    description:
      'We supply technology materials and build skills through specialised technical training.',
    sectionTopic: 'general trade and technical training',
    ctaTitle: 'Grow your skills with us',
    ctaDescription:
      'Ask about our courses or request a quote for equipment and materials supply.',
    ctaButton: 'View available courses',
    ctaButton2: 'Request a quote',
    ctaLink2: '/contato',
    items: items(consultoriaItemsEn),
  },
  fr: {
    h1Main: 'Commerce général et',
    h1Highlight: 'formation technique',
    description:
      'Nous fournissons des matériels technologiques et développons les compétences grâce à des formations techniques spécialisées.',
    sectionTopic: 'commerce général et formation technique',
    ctaTitle: 'Développez vos compétences avec nous',
    ctaDescription:
      'Découvrez nos cours ou demandez un devis pour la fourniture de matériels et d’équipements.',
    ctaButton: 'Voir les formations',
    ctaButton2: 'Demander un devis',
    ctaLink2: '/contato',
    items: items(consultoriaItemsFr),
  },
}

const devSoftItemsPt = [
  ['Aplicações Web', 'Desenvolvimento de aplicações web modernas e responsivas'],
  ['Sistemas Mobile', 'Aplicativos móveis nativos e híbridos para iOS e Android'],
  ['APIs REST', 'APIs robustas e escaláveis para integração de sistemas'],
  ['Integração de Sistemas', 'Conectamos diferentes sistemas para otimizar processos'],
]
const devSoftItemsEn = [
  ['Web applications', 'Modern, responsive web applications'],
  ['Mobile systems', 'Native and hybrid apps for iOS and Android'],
  ['REST APIs', 'Robust, scalable APIs for system integration'],
  ['System integration', 'Connecting systems to streamline processes'],
]
const devSoftItemsFr = [
  ['Applications web', 'Applications web modernes et responsives'],
  ['Mobile', 'Applications natives et hybrides iOS et Android'],
  ['APIs REST', 'APIs robustes et évolutives pour l’intégration'],
  ['Intégration de systèmes', 'Connexion de systèmes pour optimiser les processus'],
]

const desenvolvimentoSoftware = {
  pt: {
    h1Main: 'Desenvolvimento de',
    h1Highlight: 'Software',
    description:
      'Criamos soluções de software personalizadas para atender às necessidades específicas do seu negócio, desde aplicações web até sistemas empresariais complexos.',
    sectionTopic: 'desenvolvimento de software',
    ctaTitle: 'Pronto para desenvolver sua solução?',
    ctaDescription: 'Transforme suas ideias em software funcional com nossa equipe especializada.',
    ctaButton: 'Solicitar Orçamento',
    ctaButton2: 'Ver Portfolio',
    ctaLink2: '/portfolio',
    items: items(devSoftItemsPt),
  },
  en: {
    h1Main: 'Software',
    h1Highlight: 'development',
    description:
      'Tailored software, from web apps to complex enterprise systems, built around your business needs.',
    sectionTopic: 'software development',
    ctaTitle: 'Ready to build your solution?',
    ctaDescription: 'Turn ideas into working software with our specialised team.',
    ctaButton: 'Request a quote',
    ctaButton2: 'View portfolio',
    ctaLink2: '/portfolio',
    items: items(devSoftItemsEn),
  },
  fr: {
    h1Main: 'Développement',
    h1Highlight: 'logiciel',
    description:
      'Des solutions logicielles sur mesure, des applications web aux systèmes d’entreprise complexes.',
    sectionTopic: 'développement logiciel',
    ctaTitle: 'Prêt à développer votre solution ?',
    ctaDescription: 'Concrétisez vos idées avec notre équipe spécialisée.',
    ctaButton: 'Demander un devis',
    ctaButton2: 'Voir le portfolio',
    ctaLink2: '/portfolio',
    items: items(devSoftItemsFr),
  },
}

const consultTiItemsPt = [
  ['Análise de Processos', 'Análise detalhada dos processos de TI da sua empresa'],
  ['Arquitetura de Sistemas', 'Design e implementação de arquiteturas escaláveis'],
  ['Segurança Digital', 'Implementação de políticas e sistemas de segurança'],
  ['Migração Cloud', 'Migração segura e eficiente para ambientes cloud'],
]
const consultTiItemsEn = [
  ['Process analysis', 'In-depth review of your IT processes'],
  ['Systems architecture', 'Design and implementation of scalable architectures'],
  ['Digital security', 'Security policies and tooling'],
  ['Cloud migration', 'Safe, efficient moves to the cloud'],
]
const consultTiItemsFr = [
  ['Analyse des processus', 'Analyse approfondie de vos processus IT'],
  ['Architecture système', 'Conception et mise en œuvre d’architectures évolutives'],
  ['Sécurité numérique', 'Politiques et dispositifs de sécurité'],
  ['Migration cloud', 'Transitions sécurisées et efficaces vers le cloud'],
]

const consultoriaTi = {
  pt: {
    h1Main: 'Consultoria em',
    h1Highlight: 'TI',
    description:
      'Oferecemos consultoria estratégica para otimizar seus processos de TI, reduzir custos e aumentar a eficiência operacional da sua empresa.',
    sectionTopic: 'consultoria em ti',
    ctaTitle: 'Pronto para otimizar sua TI?',
    ctaDescription: 'Maximize a eficiência dos seus sistemas com nossa consultoria especializada.',
    ctaButton: 'Solicitar Consultoria',
    ctaButton2: 'Conheça Nossa Metodologia',
    ctaLink2: '/metodologia',
    items: items(consultTiItemsPt),
  },
  en: {
    h1Main: 'IT',
    h1Highlight: 'consulting',
    description:
      'Strategic consulting to optimise IT processes, reduce costs and improve operational efficiency.',
    sectionTopic: 'IT consulting',
    ctaTitle: 'Ready to optimise your IT?',
    ctaDescription: 'Get more from your systems with our specialised consultants.',
    ctaButton: 'Request consulting',
    ctaButton2: 'Our methodology',
    ctaLink2: '/metodologia',
    items: items(consultTiItemsEn),
  },
  fr: {
    h1Main: 'Conseil',
    h1Highlight: 'en informatique',
    description:
      'Conseil stratégique pour optimiser vos processus IT, réduire les coûts et gagner en efficacité.',
    sectionTopic: 'conseil en informatique',
    ctaTitle: 'Prêt à optimiser votre IT ?',
    ctaDescription: 'Tirez le meilleur parti de vos systèmes avec nos consultants.',
    ctaButton: 'Demander un conseil',
    ctaButton2: 'Notre méthodologie',
    ctaLink2: '/metodologia',
    items: items(consultTiItemsFr),
  },
}

const suporteItemsPt = [
  ['Monitoramento 24/7', 'Monitoramento contínuo de sistemas e infraestrutura'],
  ['Manutenção Preventiva', 'Manutenção proativa para evitar problemas futuros'],
  ['Resolução de Problemas', 'Solução rápida e eficiente de incidentes técnicos'],
  ['Treinamento de Equipe', 'Capacitação da sua equipe em tecnologias e processos'],
]
const suporteItemsEn = [
  ['24/7 monitoring', 'Continuous monitoring of systems and infrastructure'],
  ['Preventive maintenance', 'Proactive care to prevent issues'],
  ['Incident resolution', 'Fast, effective technical troubleshooting'],
  ['Team training', 'Upskilling your team on tools and processes'],
]
const suporteItemsFr = [
  ['Supervision 24/7', 'Surveillance continue des systèmes et de l’infrastructure'],
  ['Maintenance préventive', 'Actions proactives pour éviter les pannes'],
  ['Résolution d’incidents', 'Dépannage rapide et efficace'],
  ['Formation des équipes', 'Montée en compétences sur technologies et processus'],
]

const suporteTecnico = {
  pt: {
    h1Main: 'Suporte',
    h1Highlight: 'Técnico',
    description:
      'Garantimos o funcionamento contínuo dos seus sistemas com suporte técnico especializado 24/7, minimizando interrupções nos seus negócios.',
    sectionTopic: 'suporte técnico',
    ctaTitle: 'Pronto para ter suporte 24/7?',
    ctaDescription: 'Garanta a continuidade dos seus negócios com nosso suporte especializado.',
    ctaButton: 'Solicitar Suporte',
    ctaButton2: 'Ver Planos',
    ctaLink2: '/planos',
    items: items(suporteItemsPt),
  },
  en: {
    h1Main: 'Technical',
    h1Highlight: 'support',
    description:
      'Keep systems running with specialist 24/7 support and fewer business interruptions.',
    sectionTopic: 'technical support',
    ctaTitle: 'Need 24/7 support?',
    ctaDescription: 'Protect business continuity with our dedicated support team.',
    ctaButton: 'Request support',
    ctaButton2: 'View plans',
    ctaLink2: '/planos',
    items: items(suporteItemsEn),
  },
  fr: {
    h1Main: 'Support',
    h1Highlight: 'technique',
    description:
      'Assurez la continuité de vos systèmes avec un support spécialisé 24h/24 et moins d’interruptions.',
    sectionTopic: 'support technique',
    ctaTitle: 'Besoin d’un support 24/7 ?',
    ctaDescription: 'Sécurisez la continuité d’activité avec nos équipes dédiées.',
    ctaButton: 'Demander du support',
    ctaButton2: 'Voir les offres',
    ctaLink2: '/planos',
    items: items(suporteItemsFr),
  },
}

const transDigItemsPt = [
  ['Automação de Processos', 'Automação inteligente de processos empresariais'],
  ['Inteligência Artificial', 'Implementação de soluções de IA e machine learning'],
  ['Análise de Dados', 'Business intelligence e análise avançada de dados'],
  ['Modernização de Sistemas', 'Atualização e modernização de sistemas legados'],
]
const transDigItemsEn = [
  ['Process automation', 'Intelligent automation of business workflows'],
  ['Artificial intelligence', 'AI and machine learning solutions'],
  ['Data analytics', 'Business intelligence and advanced analytics'],
  ['System modernisation', 'Upgrading and modernising legacy systems'],
]
const transDigItemsFr = [
  ['Automatisation des processus', 'Automatisation intelligente des flux métiers'],
  ['Intelligence artificielle', 'Solutions d’IA et de machine learning'],
  ['Analyse des données', 'Business intelligence et analyses avancées'],
  ['Modernisation des systèmes', 'Mise à jour des systèmes historiques'],
]

const transformacaoDigital = {
  pt: {
    h1Main: 'Transformação',
    h1Highlight: 'Digital',
    description:
      'Aceleramos a transformação digital da sua empresa com tecnologias inovadoras, automação de processos e soluções inteligentes.',
    sectionTopic: 'transformação digital',
    ctaTitle: 'Pronto para a transformação digital?',
    ctaDescription:
      'Leve sua empresa ao futuro com tecnologias inovadoras e processos automatizados.',
    ctaButton: 'Iniciar Transformação',
    ctaButton2: 'Ver Cases de Sucesso',
    ctaLink2: '/cases',
    items: items(transDigItemsPt),
  },
  en: {
    h1Main: 'Digital',
    h1Highlight: 'transformation',
    description:
      'Accelerate transformation with innovative tech, automation and smart solutions.',
    sectionTopic: 'digital transformation',
    ctaTitle: 'Ready to transform?',
    ctaDescription: 'Move your company forward with innovation and automation.',
    ctaButton: 'Start transformation',
    ctaButton2: 'Success stories',
    ctaLink2: '/cases',
    items: items(transDigItemsEn),
  },
  fr: {
    h1Main: 'Transformation',
    h1Highlight: 'numérique',
    description:
      'Accélérez votre transformation avec technologies innovantes, automatisation et solutions intelligentes.',
    sectionTopic: 'transformation numérique',
    ctaTitle: 'Prêt pour la transformation ?',
    ctaDescription: 'Faites évoluer votre entreprise avec innovation et automatisation.',
    ctaButton: 'Démarrer',
    ctaButton2: 'Cas clients',
    ctaLink2: '/cases',
    items: items(transDigItemsFr),
  },
}

const imobiliarioItemsPt = [
  [
    'Intermediação imobiliária',
    'Intermediação na compra, venda e arrendamento de imóveis residenciais, comerciais e industriais.',
  ],
  [
    'Promoção e divulgação',
    'Promoção e divulgação estratégica de imóveis em plataformas digitais e redes sociais.',
  ],
  [
    'Gestão de propriedades',
    'Gestão de propriedades: administração de imóveis e contratos.',
  ],
  [
    'Consultoria imobiliária',
    'Consultoria imobiliária para investidores e empresas.',
  ],
  [
    'Avaliação e valorização',
    'Avaliação e valorização de imóveis com base no mercado atual.',
  ],
  [
    'Captação e portfólio',
    'Captação de imóveis e criação de portfólio imobiliário.',
  ],
  [
    'Apoio jurídico e documental',
    'Apoio jurídico e documental no processo de aquisição ou arrendamento.',
  ],
  [
    'Marketing imobiliário',
    'Elaboração de estratégias de marketing imobiliário para rápida comercialização.',
  ],
  [
    'Projetos imobiliários',
    'Desenvolvimento de projetos imobiliários em parceria com investidores.',
  ],
]
const imobiliarioItemsEn = [
  [
    'Real estate brokerage',
    'Intermediation for purchase, sale and lease of residential, commercial and industrial properties.',
  ],
  [
    'Promotion & visibility',
    'Strategic promotion of properties on digital platforms and social media.',
  ],
  [
    'Property management',
    'Property and contract administration.',
  ],
  [
    'Real estate consulting',
    'Advisory for investors and companies.',
  ],
  [
    'Valuation',
    'Property appraisal and value enhancement based on current market data.',
  ],
  [
    'Acquisition & portfolio',
    'Property sourcing and real estate portfolio building.',
  ],
  [
    'Legal & documentation support',
    'Legal and documentary support for acquisition or lease processes.',
  ],
  [
    'Real estate marketing',
    'Marketing strategies designed for faster sales and lettings.',
  ],
  [
    'Development projects',
    'Real estate project development in partnership with investors.',
  ],
]
const imobiliarioItemsFr = [
  [
    'Intermédiation immobilière',
    'Achat, vente et location de biens résidentiels, commerciaux et industriels.',
  ],
  [
    'Promotion et visibilité',
    'Promotion stratégique sur les plateformes digitales et les réseaux sociaux.',
  ],
  [
    'Gestion de patrimoine',
    'Administration des biens et des contrats.',
  ],
  [
    'Conseil immobilier',
    'Accompagnement des investisseurs et des entreprises.',
  ],
  [
    'Évaluation et valorisation',
    'Estimation et mise en valeur des biens selon le marché actuel.',
  ],
  [
    'Captation et portefeuille',
    'Captation de biens et constitution d’un portefeuille immobilier.',
  ],
  [
    'Appui juridique et documentaire',
    'Soutien juridique et documentaire pour acquisition ou location.',
  ],
  [
    'Marketing immobilier',
    'Stratégies de marketing pour accélérer la commercialisation.',
  ],
  [
    'Projets immobiliers',
    'Développement de projets en partenariat avec des investisseurs.',
  ],
]

const imobiliario = {
  pt: {
    h1Main: 'Comercialização imobiliária e',
    h1Highlight: 'serviços imobiliários',
    description:
      'Soluções estratégicas para compra, venda, arrendamento e gestão de imóveis, com tecnologia, marketing digital e conhecimento de mercado.',
    sectionTopic: 'comercialização imobiliária e serviços imobiliários',
    ctaTitle: 'Quer comprar, vender ou arrendar com a SOSVOR?',
    ctaDescription:
      'Fale connosco para uma primeira conversa sem compromisso e descubra como potenciamos o seu projeto imobiliário.',
    ctaButton: 'Contactar equipa imobiliária',
    ctaButton2: 'Ver todos os serviços',
    ctaLink2: '/',
    items: items(imobiliarioItemsPt),
    diferencial: {
      title: 'Diferencial SOSVOR',
      description:
        'Integramos engenharia, tecnologia e marketing para uma abordagem única: maior visibilidade, valorização dos ativos e fechamento de negócios com mais eficiência.',
    },
  },
  en: {
    h1Main: 'Real estate sales &',
    h1Highlight: 'property services',
    description:
      'Strategic solutions for buying, selling, letting and property management, backed by technology, digital marketing and market expertise.',
    sectionTopic: 'real estate commercialisation and property services',
    ctaTitle: 'Buying, selling or letting with SOSVOR?',
    ctaDescription:
      'Get in touch for an initial conversation and see how we can support your real estate goals.',
    ctaButton: 'Contact the property team',
    ctaButton2: 'All services',
    ctaLink2: '/',
    items: items(imobiliarioItemsEn),
    diferencial: {
      title: 'The SOSVOR edge',
      description:
        'We combine engineering, technology and marketing for a distinctive approach: stronger visibility, asset uplift and more efficient deal closing.',
    },
  },
  fr: {
    h1Main: 'Commercialisation immobilière et',
    h1Highlight: 'services immobiliers',
    description:
      'Solutions stratégiques pour l’achat, la vente, la location et la gestion de biens, avec technologie, marketing digital et expertise du marché.',
    sectionTopic: 'commercialisation immobilière et services immobiliers',
    ctaTitle: 'Acheter, vendre ou louer avec SOSVOR ?',
    ctaDescription:
      'Contactez-nous pour un premier échange sans engagement et découvrez comment nous valorisons votre projet immobilier.',
    ctaButton: 'Contacter l’équipe immobilière',
    ctaButton2: 'Tous les services',
    ctaLink2: '/',
    items: items(imobiliarioItemsFr),
    diferencial: {
      title: 'Avantage SOSVOR',
      description:
        'Nous intégrons ingénierie, technologie et marketing : visibilité accrue, valorisation des actifs et transactions plus efficaces.',
    },
  },
}

const bySlug = {
  'engenharia-civil': engCivil,
  tecnologia,
  ciberseguranca,
  'gestao-processos': gestaoProcessos,
  'aplicacoes-gestao': aplicacoesGestao,
  'design-marketing': designMarketing,
  'seguranca-eletronica': seguranca,
  turismo,
  consultoria,
  imobiliario,
  'desenvolvimento-software': desenvolvimentoSoftware,
  'consultoria-ti': consultoriaTi,
  'suporte-tecnico': suporteTecnico,
  'transformacao-digital': transformacaoDigital,
}

const LOCALES = new Set(['pt', 'en', 'fr'])

const SERVICE_INTRO_BACKGROUNDS = {
  'gestao-processos': '/img/gestao-processos-intro-bg.png',
  'aplicacoes-gestao': '/img/aplicacoes-gestao-intro-bg.png',
  imobiliario: '/img/imobiliario-intro-bg.png',
}

function serviceIntroBackground(slug) {
  if (SERVICE_INTRO_BACKGROUNDS[slug]) return SERVICE_INTRO_BACKGROUNDS[slug]
  const alias = { 'gestao-processos': 'aplicacoes-gestao' }
  const fileSlug = alias[slug] || slug
  return `/img/servicos/${fileSlug}.png`
}

/** Missão, Proposta de Valor e Área de Actuação por serviço (exceto packs que já definem introItems). */
const INTRO_ITEMS = {
  'engenharia-civil': {
    pt: items([
      [
        'Missão, Construir com excelência e sustentabilidade',
        'Transformamos projectos em obras concretas com rigor técnico, planeamento integrado e compromisso com eficiência energética e impacto ambiental reduzido.',
      ],
      [
        'Proposta de Valor, Soluções completas de ponta a ponta',
        'Acompanhamos cada fase, estudos, projecto, fiscalização e execução, com equipas multidisciplinares e metodologias que asseguram qualidade, prazo e controlo de custos.',
      ],
      [
        'Área de Actuação, Do residencial ao industrial',
        'Actuamos em obras civis, infraestruturas, manutenção predial e licenciamento, com foco em sustentabilidade e conformidade regulatória em Angola e mercados parceiros.',
      ],
    ]),
    en: items([
      [
        'Mission, Build with excellence and sustainability',
        'We turn projects into delivered works with technical rigour, integrated planning and a commitment to energy efficiency and lower environmental impact.',
      ],
      [
        'Value proposition, End-to-end delivery',
        'We support every phase, studies, design, supervision and construction, with multidisciplinary teams and methods that protect quality, schedule and cost control.',
      ],
      [
        'Scope, Residential to industrial',
        'Civil works, infrastructure, building maintenance and permitting, with sustainability and regulatory compliance in Angola and partner markets.',
      ],
    ]),
    fr: items([
      [
        'Mission, Construire avec excellence et durabilité',
        'Nous concrétisons les projets avec rigueur technique, planification intégrée et engagement pour l’efficacité énergétique et un impact environnemental maîtrisé.',
      ],
      [
        'Proposition de valeur, Solutions complètes de bout en bout',
        'Nous accompagnons chaque phase, études, conception, surveillance et réalisation, avec des équipes pluridisciplinaires et des méthodes qui garantissent qualité, délais et coûts.',
      ],
      [
        'Périmètre, Du résidentiel à l’industriel',
        'Ouvrages civils, infrastructures, maintenance immobilière et autorisations, avec durabilité et conformité réglementaire en Angola et sur les marchés partenaires.',
      ],
    ]),
  },
  tecnologia: {
    pt: items([
      [
        'Missão, Inovar com tecnologia que gera resultados',
        'Impulsionamos organizações com soluções digitais fiáveis que ligam software, dados e infraestrutura às prioridades reais do negócio.',
      ],
      [
        'Proposta de Valor, Ecossistema tecnológico integrado',
        'Desenvolvimento, integração, cloud e suporte numa abordagem coerente: menos silos, mais visibilidade e capacidade de escalar com segurança.',
      ],
      [
        'Área de Actuação, Do código à operação',
        'Cobrimos desenvolvimento web e mobile, plataformas digitais, ERP, BI, transformação digital e infraestrutura de TI para empresas e instituições.',
      ],
    ]),
    en: items([
      [
        'Mission, Innovate with technology that delivers',
        'We help organisations move faster with reliable digital solutions that connect software, data and infrastructure to real business priorities.',
      ],
      [
        'Value proposition, An integrated technology stack',
        'Development, integration, cloud and support in one coherent approach: fewer silos, better visibility and secure scalability.',
      ],
      [
        'Scope, From code to operations',
        'Web and mobile development, digital platforms, ERP, BI, digital transformation and IT infrastructure for companies and institutions.',
      ],
    ]),
    fr: items([
      [
        'Mission, Innover avec une technologie utile',
        'Nous faisons progresser les organisations grâce à des solutions numériques fiables qui relient logiciels, données et infrastructure aux priorités métier.',
      ],
      [
        'Proposition de valeur, Écosystème technologique intégré',
        'Développement, intégration, cloud et support dans une approche cohérente : moins de silos, plus de visibilité et une montée en charge sécurisée.',
      ],
      [
        'Périmètre, Du code à l’exploitation',
        'Développement web et mobile, plateformes digitales, ERP, BI, transformation numérique et infrastructure IT pour entreprises et institutions.',
      ],
    ]),
  },
  ciberseguranca: {
    pt: items([
      [
        'Missão, Proteger activos digitais com confiança',
        'Damos tranquilidade operacional: a sua organização cresce enquanto a SOSVOR reforça a postura de segurança, a continuidade e a disponibilidade dos serviços.',
      ],
      [
        'Proposta de Valor, Segurança de ponta a ponta',
        'Da governança à operação 24/7, combinamos consultoria, arquitectura, testes ofensivos, SOC e serviços geridos alinhados às melhores práticas internacionais.',
      ],
      [
        'Área de Actuação, Prevenção, detecção e resposta',
        'Actuamos em políticas de SI, arquitectura de protecção, Blue/Red/Purple Team, centros de operações, MSSP e continuidade de negócio com prevenção de perda de dados.',
      ],
    ]),
    en: items([
      [
        'Mission, Protect digital assets with confidence',
        'We provide operational peace of mind: your organisation grows while SOSVOR strengthens security posture, continuity and service availability.',
      ],
      [
        'Value proposition, End-to-end security',
        'From governance to 24/7 operations, advisory, architecture, offensive testing, SOC and managed services aligned with international best practice.',
      ],
      [
        'Scope, Prevent, detect and respond',
        'Information security policies, protection architecture, Blue/Red/Purple Team, security operations centres, MSSP and business continuity with data loss prevention.',
      ],
    ]),
    fr: items([
      [
        'Mission, Protéger les actifs numériques en toute confiance',
        'Nous apportons sérénité opérationnelle : votre organisation se développe pendant que SOSVOR renforce la posture de sécurité, la continuité et la disponibilité.',
      ],
      [
        'Proposition de valeur, Sécurité de bout en bout',
        'De la gouvernance à l’exploitation 24/7, conseil, architecture, tests offensifs, SOC et services managés conformes aux meilleures pratiques.',
      ],
      [
        'Périmètre, Prévenir, détecter et répondre',
        'Politiques SI, architecture de protection, Blue/Red/Purple Team, centres d’opérations, MSSP et continuité d’activité avec prévention des fuites de données.',
      ],
    ]),
  },
  'seguranca-eletronica': {
    pt: items([
      [
        'Missão, Proteger pessoas e património com inteligência',
        'Desenhamos ambientes mais seguros combinando videovigilância, controlo de acesso e monitorização inteligente adaptados a cada contexto operacional.',
      ],
      [
        'Proposta de Valor, Tecnologia integrada e proactiva',
        'Soluções electrónicas modulares com IoT, alarmes, biometria e supervisão remota para prevenir incidentes e responder com rapidez.',
      ],
      [
        'Área de Actuação, Residencial, empresarial e industrial',
        'Instalação, manutenção e consultoria de sistemas CCTV, controlo de acesso, sensores e plataformas cloud para edifícios, empresas e infraestruturas críticas.',
      ],
    ]),
    en: items([
      [
        'Mission, Protect people and assets intelligently',
        'We design safer environments by combining video surveillance, access control and smart monitoring tailored to each operational context.',
      ],
      [
        'Value proposition, Integrated, proactive technology',
        'Modular electronic security with IoT, alarms, biometrics and remote supervision to prevent incidents and respond quickly.',
      ],
      [
        'Scope, Residential, business and industrial',
        'Installation, maintenance and consulting for CCTV, access control, sensors and cloud platforms for buildings, companies and critical infrastructure.',
      ],
    ]),
    fr: items([
      [
        'Mission, Protéger personnes et biens avec intelligence',
        'Nous concevons des environnements plus sûrs en combinant vidéosurveillance, contrôle d’accès et supervision intelligente adaptée à chaque contexte.',
      ],
      [
        'Proposition de valeur, Technologie intégrée et proactive',
        'Solutions électroniques modulaires avec IoT, alarmes, biométrie et télésurveillance pour prévenir les incidents et réagir rapidement.',
      ],
      [
        'Périmètre, Résidentiel, entreprise et industriel',
        'Installation, maintenance et conseil en CCTV, contrôle d’accès, capteurs et plateformes cloud pour bâtiments, entreprises et infrastructures critiques.',
      ],
    ]),
  },
  'design-marketing': {
    pt: items([
      [
        'Missão, Comunicar marcas com impacto visual',
        'Traduzimos a essência de cada organização em identidades visuais memoráveis que reforçam credibilidade e reconhecimento no mercado.',
      ],
      [
        'Proposta de Valor, Criatividade estratégica e consistente',
        'Do branding ao digital, entregamos design gráfico, editorial, UI/UX e campanhas com coerência estética e mensagens alinhadas aos objectivos de negócio.',
      ],
      [
        'Área de Actuação, Identidade, digital e campanhas',
        'Logótipos, materiais institucionais, interfaces web e mobile, peças publicitárias, vídeo institucional e consultoria criativa para comunicação e marketing.',
      ],
    ]),
    en: items([
      [
        'Mission, Communicate brands with visual impact',
        'We express each organisation’s essence through memorable visual identities that build credibility and market recognition.',
      ],
      [
        'Value proposition, Strategic, consistent creativity',
        'From branding to digital, graphic and editorial design, UI/UX and campaigns with coherent aesthetics and business-aligned messaging.',
      ],
      [
        'Scope, Identity, digital and campaigns',
        'Logos, institutional materials, web and mobile interfaces, advertising assets, corporate video and creative consulting for communication and marketing.',
      ],
    ]),
    fr: items([
      [
        'Mission, Communiquer les marques avec impact visuel',
        'Nous traduisons l’essence de chaque organisation en identités visuelles mémorables qui renforcent crédibilité et notoriété.',
      ],
      [
        'Proposition de valeur, Créativité stratégique et cohérente',
        'Du branding au digital, design graphique et éditorial, UI/UX et campagnes avec une esthétique cohérente et des messages alignés sur les objectifs.',
      ],
      [
        'Périmètre, Identité, digital et campagnes',
        'Logos, supports institutionnels, interfaces web et mobile, visuels publicitaires, vidéo institutionnelle et conseil créatif en communication et marketing.',
      ],
    ]),
  },
  consultoria: {
    pt: items([
      [
        'Missão, Fornecer e capacitar com excelência',
        'Aproximamos organizações de materiais, equipamentos e conhecimento técnico de qualidade, reforçando autonomia e competitividade.',
      ],
      [
        'Proposta de Valor, Comércio e formação integrados',
        'Combinamos fornecimento tecnológico, importação/exportação e programas de capacitação especializados em áreas críticas para o mercado angolano.',
      ],
      [
        'Área de Actuação, Tecnologia, engenharia e design',
        'Materiais e soluções tecnológicas, cursos técnicos, workshops, formações em TI, engenharia, segurança e design, com parcerias estratégicas de longo prazo.',
      ],
    ]),
    en: items([
      [
        'Mission, Supply and upskill with excellence',
        'We connect organisations to quality materials, equipment and technical knowledge, strengthening autonomy and competitiveness.',
      ],
      [
        'Value proposition, Integrated trade and training',
        'Technology supply, import/export and specialised upskilling programmes in areas critical to the Angolan market.',
      ],
      [
        'Scope, Technology, engineering and design',
        'Technology materials and solutions, technical courses, workshops, training in IT, engineering, security and design, with long-term strategic partnerships.',
      ],
    ]),
    fr: items([
      [
        'Mission, Fournir et former avec excellence',
        'Nous rapprochons les organisations de matériels, équipements et savoir-faire technique de qualité, en renforçant autonomie et compétitivité.',
      ],
      [
        'Proposition de valeur, Commerce et formation intégrés',
        'Fourniture technologique, import-export et programmes de montée en compétences spécialisés pour le marché angolais.',
      ],
      [
        'Périmètre, Technologie, ingénierie et design',
        'Matériels et solutions technologiques, cours techniques, ateliers, formations en IT, ingénierie, sécurité et design, avec partenariats stratégiques durables.',
      ],
    ]),
  },
  turismo: {
    pt: items([
      [
        'Missão, Transformar viagens em experiências',
        'Criamos itinerários personalizados que combinam conforto, segurança e atendimento de excelência para cada perfil de viajante.',
      ],
      [
        'Proposta de Valor, Planeamento completo e suporte dedicado',
        'Da cotação à reserva, tratamos passagens, hospedagem, documentação, seguros e logística com plataforma digital e equipa disponível 24h.',
      ],
      [
        'Área de Actuação, Pessoal, corporativo e MICE',
        'Viagens de lazer, negócios e eventos (MICE), pacotes temáticos, concierge VIP e gestão de reservas para particulares e empresas.',
      ],
    ]),
    en: items([
      [
        'Mission, Turn travel into experiences',
        'We craft personalised itineraries that combine comfort, safety and outstanding service for every traveller profile.',
      ],
      [
        'Value proposition, Full planning and dedicated support',
        'From quotes to bookings, flights, accommodation, documents, insurance and logistics with a digital platform and 24/7 team.',
      ],
      [
        'Scope, Leisure, corporate and MICE',
        'Leisure and business travel, events (MICE), themed packages, VIP concierge and reservation management for individuals and companies.',
      ],
    ]),
    fr: items([
      [
        'Mission, Transformer les voyages en expériences',
        'Nous créons des itinéraires personnalisés alliant confort, sécurité et service d’excellence pour chaque profil de voyageur.',
      ],
      [
        'Proposition de valeur, Planification complète et accompagnement dédié',
        'Du devis à la réservation, vols, hébergement, documents, assurances et logistique avec plateforme digitale et équipe disponible 24h/24.',
      ],
      [
        'Périmètre, Loisirs, corporate et MICE',
        'Voyages de loisirs et d’affaires, événements (MICE), forfaits thématiques, conciergerie VIP et gestion des réservations pour particuliers et entreprises.',
      ],
    ]),
  },
  imobiliario: {
    pt: items([
      [
        'Missão, Valorizar e facilitar transacções imobiliárias',
        'Apoiamos compradores, vendedores e investidores com processos transparentes, marketing eficaz e conhecimento profundo do mercado.',
      ],
      [
        'Proposta de Valor, Engenharia, tecnologia e marketing unidos',
        'Integramos intermediação, promoção digital, gestão de propriedades e consultoria numa abordagem única que acelera negócios e valoriza activos.',
      ],
      [
        'Área de Actuação, Compra, venda, arrendamento e gestão',
        'Intermediação residencial e comercial, avaliação, captação de imóveis, apoio jurídico, marketing imobiliário e desenvolvimento de projectos com investidores.',
      ],
    ]),
    en: items([
      [
        'Mission, Add value and simplify property deals',
        'We support buyers, sellers and investors with transparent processes, effective marketing and deep market knowledge.',
      ],
      [
        'Value proposition, Engineering, technology and marketing combined',
        'Brokerage, digital promotion, property management and advisory in one approach that speeds deals and uplifts asset value.',
      ],
      [
        'Scope, Buy, sell, let and manage',
        'Residential and commercial brokerage, valuation, property sourcing, legal support, real estate marketing and development projects with investors.',
      ],
    ]),
    fr: items([
      [
        'Mission, Valoriser et faciliter les transactions immobilières',
        'Nous accompagnons acheteurs, vendeurs et investisseurs avec des processus transparents, un marketing efficace et une connaissance fine du marché.',
      ],
      [
        'Proposition de valeur, Ingénierie, technologie et marketing réunis',
        'Intermédiation, promotion digitale, gestion de patrimoine et conseil dans une approche unique qui accélère les transactions et valorise les actifs.',
      ],
      [
        'Périmètre, Achat, vente, location et gestion',
        'Intermédiation résidentielle et commerciale, évaluation, captation de biens, appui juridique, marketing immobilier et projets avec investisseurs.',
      ],
    ]),
  },
  'desenvolvimento-software': {
    pt: items([
      [
        'Missão, Software à medida do seu negócio',
        'Desenvolvemos aplicações que resolvem problemas reais, com arquitectura sólida e foco na experiência de utilizador e na manutenção a longo prazo.',
      ],
      [
        'Proposta de Valor, Da ideia ao produto em produção',
        'Web, mobile, APIs e integrações entregues com qualidade, escalabilidade e alinhamento às regras de negócio da sua organização.',
      ],
      [
        'Área de Actuação, Aplicações web, mobile e integração',
        'Sistemas responsivos, apps iOS/Android, APIs REST robustas e ligação a ERPs e plataformas existentes para optimizar processos.',
      ],
    ]),
    en: items([
      [
        'Mission, Software built around your business',
        'We build applications that solve real problems with solid architecture, strong UX and long-term maintainability.',
      ],
      [
        'Value proposition, From idea to production',
        'Web, mobile, APIs and integrations delivered with quality, scalability and alignment to your organisation’s business rules.',
      ],
      [
        'Scope, Web, mobile and integration',
        'Responsive systems, iOS/Android apps, robust REST APIs and connections to ERPs and existing platforms to streamline processes.',
      ],
    ]),
    fr: items([
      [
        'Mission, Logiciel adapté à votre activité',
        'Nous développons des applications qui résolvent des problèmes concrets, avec une architecture solide, une bonne UX et une maintenance durable.',
      ],
      [
        'Proposition de valeur, De l’idée à la production',
        'Web, mobile, APIs et intégrations livrés avec qualité, évolutivité et alignement sur les règles métier de votre organisation.',
      ],
      [
        'Périmètre, Web, mobile et intégration',
        'Systèmes responsives, apps iOS/Android, APIs REST robustes et connexion aux ERP et plateformes existantes pour optimiser les processus.',
      ],
    ]),
  },
  'consultoria-ti': {
    pt: items([
      [
        'Missão, Optimizar TI com visão estratégica',
        'Ajudamos a reduzir custos, mitigar riscos e aumentar a eficiência dos sistemas através de diagnósticos objectivos e roadmaps claros.',
      ],
      [
        'Proposta de Valor, Conselho independente e pragmático',
        'Análise de processos, arquitectura, segurança e cloud com recomendações executáveis alinhadas à realidade orçamental e operacional.',
      ],
      [
        'Área de Actuação, Processos, arquitectura e migração',
        'Revisão de processos de TI, desenho de arquitecturas escaláveis, políticas de segurança digital e migração segura para ambientes cloud.',
      ],
    ]),
    en: items([
      [
        'Mission, Optimise IT with strategic insight',
        'We help cut costs, reduce risk and improve system efficiency through objective assessments and clear roadmaps.',
      ],
      [
        'Value proposition, Independent, pragmatic advice',
        'Process, architecture, security and cloud reviews with actionable recommendations aligned to budget and operations.',
      ],
      [
        'Scope, Processes, architecture and migration',
        'IT process review, scalable architecture design, digital security policies and safe migration to cloud environments.',
      ],
    ]),
    fr: items([
      [
        'Mission, Optimiser l’IT avec une vision stratégique',
        'Nous aidons à réduire les coûts, limiter les risques et améliorer l’efficacité des systèmes grâce à des diagnostics objectifs et des feuilles de route claires.',
      ],
      [
        'Proposition de valeur, Conseil indépendant et pragmatique',
        'Analyse des processus, architecture, sécurité et cloud avec des recommandations actionnables alignées sur le budget et l’exploitation.',
      ],
      [
        'Périmètre, Processus, architecture et migration',
        'Revue des processus IT, conception d’architectures évolutives, politiques de sécurité numérique et migration sécurisée vers le cloud.',
      ],
    ]),
  },
  'suporte-tecnico': {
    pt: items([
      [
        'Missão, Garantir continuidade operacional',
        'Mantemos sistemas e infraestruturas disponíveis com suporte especializado que minimiza paragens e impacto no negócio.',
      ],
      [
        'Proposta de Valor, Resposta rápida e manutenção proactiva',
        'Monitorização 24/7, manutenção preventiva e resolução estruturada de incidentes com equipas experientes e SLAs claros.',
      ],
      [
        'Área de Actuação, Infraestrutura, equipamentos e equipas',
        'Supervisão contínua, helpdesk, manutenção de hardware, suporte remoto e capacitação de colaboradores em ferramentas e boas práticas.',
      ],
    ]),
    en: items([
      [
        'Mission, Ensure operational continuity',
        'We keep systems and infrastructure available with specialist support that minimises downtime and business impact.',
      ],
      [
        'Value proposition, Fast response and proactive care',
        '24/7 monitoring, preventive maintenance and structured incident resolution with experienced teams and clear SLAs.',
      ],
      [
        'Scope, Infrastructure, devices and teams',
        'Continuous supervision, helpdesk, hardware maintenance, remote support and staff training on tools and best practice.',
      ],
    ]),
    fr: items([
      [
        'Mission, Garantir la continuité opérationnelle',
        'Nous maintenons systèmes et infrastructures disponibles avec un support spécialisé qui limite les interruptions et l’impact sur l’activité.',
      ],
      [
        'Proposition de valeur, Réponse rapide et maintenance proactive',
        'Supervision 24/7, maintenance préventive et résolution structurée des incidents avec des équipes expérimentées et des SLA clairs.',
      ],
      [
        'Périmètre, Infrastructure, équipements et équipes',
        'Surveillance continue, helpdesk, maintenance matérielle, support à distance et formation des collaborateurs aux outils et bonnes pratiques.',
      ],
    ]),
  },
  'transformacao-digital': {
    pt: items([
      [
        'Missão, Acelerar a evolução digital das organizações',
        'Modernizamos processos e sistemas com tecnologias que aumentam produtividade, reduzem custos e abrem novas oportunidades de negócio.',
      ],
      [
        'Proposta de Valor, Automação, dados e modernização',
        'Combinamos automação inteligente, IA, analytics e actualização de legados num plano coerente de transformação com resultados mensuráveis.',
      ],
      [
        'Área de Actuação, Processos, dados e sistemas legados',
        'Automação de fluxos empresariais, soluções de IA e machine learning, business intelligence e modernização de aplicações e infraestruturas antigas.',
      ],
    ]),
    en: items([
      [
        'Mission, Accelerate organisational digital evolution',
        'We modernise processes and systems with technology that boosts productivity, cuts costs and unlocks new business opportunities.',
      ],
      [
        'Value proposition, Automation, data and modernisation',
        'Intelligent automation, AI, analytics and legacy renewal in a coherent transformation plan with measurable outcomes.',
      ],
      [
        'Scope, Processes, data and legacy systems',
        'Business workflow automation, AI and machine learning solutions, business intelligence and modernisation of legacy applications and infrastructure.',
      ],
    ]),
    fr: items([
      [
        'Mission, Accélérer l’évolution numérique des organisations',
        'Nous modernisons processus et systèmes avec des technologies qui augmentent la productivité, réduisent les coûts et ouvrent de nouvelles opportunités.',
      ],
      [
        'Proposition de valeur, Automatisation, données et modernisation',
        'Automatisation intelligente, IA, analytique et renouvellement du legacy dans un plan de transformation cohérent avec des résultats mesurables.',
      ],
      [
        'Périmètre, Processus, données et systèmes historiques',
        'Automatisation des flux métiers, solutions d’IA et de machine learning, business intelligence et modernisation des applications et infrastructures existantes.',
      ],
    ]),
  },
}

/**
 * @param {string} locale
 * @param {string} slug
 * @returns {null | {
 *   h1Main: string,
 *   h1Highlight: string,
 *   description: string,
 *   sectionTopic: string,
 *   ctaTitle: string,
 *   ctaDescription: string,
 *   ctaButton: string,
 *   ctaButton2: string,
 *   ctaLink2: string,
 *   introItems?: { title: string, description: string }[],
 *   introBackground?: string,
 *   items: { title: string, description: string }[]
 * }}
 */
export function getServiceDetailCopy(locale, slug) {
  const loc = LOCALES.has(locale) ? locale : 'pt'
  const pack = bySlug[slug]
  if (!pack) return null
  const copy = { ...(pack[loc] || pack.pt) }
  const introPack = INTRO_ITEMS[slug]
  if (!copy.introItems && introPack) {
    copy.introItems = introPack[loc] || introPack.pt
  }
  if (!copy.introBackground) {
    copy.introBackground = serviceIntroBackground(slug)
  }
  return copy
}
